__webpack_require__.p = "/types-of-goods/";